import TipsCollection from '../../Tipping/TipsCollection';
import StreakTipView from "../StreakTip";
import StreakTipEmptyView from "../StreakTip/StreakTipEmptyView";
import _ from 'lodash';
import { Model } from 'backbone';
import Radio from 'backbone.radio';

const
	moment = require('moment'),
	withCurrency = num => `$${Math.round10(num, -2).toFixed(2)}`,
	tippingRadio = Radio.channel('tipping'),
	BYE_ROUNDS = JSON.parse(process.env.STREAK_BYE_ROUNDS),
	isBye = round_id => BYE_ROUNDS.indexOf(round_id) !== -1;

export class StreakTipsCollection extends TipsCollection {
	get childView() {
		return StreakTipView;
	}

	get emptyView(){
		return StreakTipEmptyView;
	}

	childViewEvents() {
		return {
			...super.childViewEvents(),
			'make:remove:squad': 'removeTips',

		}
	}

	initialize() {
		super.initialize();
		this.gauntlet = new Model();

		this.listenTo(tippingRadio, 'save', this.onSaveAction);
	}

	onSaveAction() {
		const round_id = this.collection.first().get('round');

		this.trigger('squad:add', {
			predict_winner_squad_id: this.gauntlet.get(round_id).predict_winner_squad_id,
			round: round_id,
			margin: this.gauntlet.get(round_id).predict_margin || 0
		});
	}

	updateTips(args) {
		if (!args) {
			return this;
		}

		tippingRadio.trigger('changed');

		let { predict_winner_squad_id, predict_margin } = args;

		const
			round_id = this.collection.first().get('round'),
			current_id = _.result(
				this.gauntlet.attributes,
				`${round_id}.predict_winner_squad_id`
			),
			current_margin = _.result(
				this.gauntlet.attributes,
				`${round_id}.margin`
			),
			is_already_selected = (
				_.eq(current_id, predict_winner_squad_id) &&
				_.eq(current_margin, predict_margin)
			);

		if (!is_already_selected) {
			return this._makeBet({
				round_id,
				predict_margin,
				current_id: predict_winner_squad_id
			});
		}

		/**
		 * On squad unselected
		 */
		return this._removeWinner({ round_id });
	}

	removeTips(args) {
		if (!args) {
			return this;
		}

		tippingRadio.trigger('changed');

		let { predict_winner_squad_id, predict_margin, round_id } = args;

		return this._removeSquad({
			round_id,
			predict_margin,
			current_id: predict_winner_squad_id
		});
	}

	_removeWinner({ round_id }) {
		this.gauntlet.unset(round_id);

		this.trigger('squad:remove', {
			round: round_id
		});

		return this;
	}

	_removeSquad({ round_id, predict_margin, current_id }) {
		const params = {
			round: round_id,
			predict_winner_squad_id: current_id,
			margin: predict_margin
		};

		this.gauntlet.set({ [round_id]: params });

		this.trigger('squad:remove', params);

		return this;
	}


	_makeBet({ round_id, predict_margin, current_id }) {
		const params = {
			round: round_id,
			predict_winner_squad_id: current_id,
			margin: predict_margin
		};

		this.gauntlet.set({ [round_id]: params });

		this.trigger('squad:add', params);

		return this;
	}

	init({ user_tips, selected_round_id }) {
		const tips = isBye(selected_round_id) ? [] : _.chain(user_tips)
			.values()
			.map(tip => ({
				...tip,
				game_date: moment(tip.date).format('ddd, Do MMM h:mma'),
				image_squads_path: process.env.SQUAD_LOGOS_PATH,
				home_squad_odds_currency: withCurrency(tip.home_squad_odds),
				away_squad_odds_currency: withCurrency(tip.away_squad_odds),
				home_squad_id: parseInt(tip.home_squad_id, 10),
				away_squad_id: parseInt(tip.away_squad_id, 10),
				is_disabled: tip.is_disabled || tip.status !== 'scheduled',
				is_completed: tip.status === 'complete',
				is_live: tip.status === 'playing',
				is_odds_visible: (
					tip.home_squad_odds && tip.away_squad_odds && tip.status !== 'complete'
				)
			}))
			.value();

		const selected_tip = _.first(tips.filter(tip => tip.predict_winner_squad_id));

		if (selected_tip) {
			this.gauntlet.set({
				[selected_tip.round]: {
					predict_winner_squad_id: selected_tip.predict_winner_squad_id,
					predict_margin: selected_tip.predict_margin
				}
			});
		}

		this.selected_round_id = selected_round_id;

		this.collection.reset(tips);
	}
}

export default StreakTipsCollection;